import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

//store
import { Provider } from "react-redux";
import store from "./store/provider";

//axios
import axios from "axios";
import { baseURL } from "./util/Config";

// type
import {
  CLOSE_SPINNER_PROGRESS,
  OPEN_SPINNER_PROGRESS,
} from "./store/spinner/types";
import { UNSET_ADMIN } from "./store/admin/types";
import {
  CONFIRM_CODE_HEADER,
  requestConfirmCode,
} from "./util/confirmCode";

axios.defaults.baseURL = baseURL;

axios.interceptors.request.use(
  (req) => {
    store.dispatch({ type: OPEN_SPINNER_PROGRESS });
    // Real Admin
    return req;
  },
  (error) => {
    console.log(error);
  }
);

axios.interceptors.response.use(
  (res) => {
    store.dispatch({ type: CLOSE_SPINNER_PROGRESS });
    return res;
  },
  async (err) => {
    if (err.message === "Network Error") {
      // store.dispatch({ type: SET_NETWORK_ERROR });
    }
    store.dispatch({ type: CLOSE_SPINNER_PROGRESS });
    // Sensitive action: ask for the authenticator code, then retry the same
    // request with it. The server answers 428 again if the code is wrong.
    if (
      err.response?.status === 428 &&
      /^STEP_UP_(REQUIRED|INVALID)$/.test(err.response?.data?.errorCode || "")
    ) {
      const answer = await requestConfirmCode(err.response.data.message);
      if (!answer) return Promise.reject(new Error("Action cancelled."));
      const headers = { ...err.config.headers };
      headers[CONFIRM_CODE_HEADER] = answer.code;
      return axios({ ...err.config, headers });
    }
    // The admin session was revoked, expired, or the admin was disabled.
    if (
      err.response?.status === 401 &&
      err.response?.data?.errorCode === "ADMIN_SESSION_INVALID" &&
      store.getState().admin.isAuth
    ) {
      store.dispatch({ type: UNSET_ADMIN });
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
